var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "news",
    d: "M121.667-820a1.6,1.6,0,0,1-1.167-.5,1.6,1.6,0,0,1-.5-1.167v-16.667a1.6,1.6,0,0,1,.5-1.167,1.6,1.6,0,0,1,1.167-.5H134.5l5.5,5.5v12.833a1.6,1.6,0,0,1-.5,1.167,1.6,1.6,0,0,1-1.167.5Zm0-1.667h16.667v-11.9h-4.75v-4.762H121.667Zm2.75-3.083h11.167v-1.667H124.417Zm0-8.833H130v-1.667h-5.583Zm0,4.417h11.167v-1.667H124.417Zm-2.75-9.167v0Z",
    transform: "translate(-120 840)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.be2f4c5f65600245cfd9caa83755dcb5.svg";
export { ForwardRef as ReactComponent };